export function createObj({ name, initialState, }) {
    return {
        schema: "obj",
        name: name,
        initialState,
        set: (value) => (state) => {
            // deno-lint-ignore no-explicit-any
            state[name] = value;
        },
        reset: () => (state) => {
            // deno-lint-ignore no-explicit-any
            state[name] = initialState;
        },
        update: (prop) => (state) => {
            // deno-lint-ignore no-explicit-any
            state[name][prop.key] = prop.value;
        },
        select: (state) => {
            // deno-lint-ignore no-explicit-any
            return state[name];
        },
    };
}
export function obj(initialState) {
    return (name) => createObj({ name, initialState });
}
